// Mirrors the flattened shape produced by flattenAssignment() in the store — i.e. what
// BE's Assignment{ id, startDate, endDate, association } looks like once unwrapped.
// startDate / endDate are YYYYMMDD integers matching the real listAssignments response.
export const DUMMY_ASSIGNMENTS = [
  {
    id: 9001,
    personnelId: 'EMP001',
    name: 'Ahmet',
    surname: 'Yılmaz',
    email: 'ahmet.yilmaz@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 10,
    departmentName: 'Engineering',
    campusName: 'Istanbul HQ',
    routeGroupId: 101,
    routeGroup: 'Morning Shuttle A',
    routeId: 201,
    routeName: 'Route Alpha',
    stationId: 301,
    stationName: 'Kadıköy Stop',
    schedule: 'REGULAR',
    startDate: 20250101,
    endDate: 20250630,
  },
  {
    id: 9002,
    personnelId: 'EMP002',
    name: 'Ayşe',
    surname: 'Kaya',
    email: 'ayse.kaya@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 10,
    departmentName: 'Engineering',
    campusName: 'Istanbul HQ',
    routeGroupId: 101,
    routeGroup: 'Morning Shuttle A',
    routeId: 201,
    routeName: 'Route Alpha',
    stationId: 302,
    stationName: 'Bostancı Stop',
    schedule: 'REGULAR',
    startDate: 20250301,
    endDate: null,
  },
  {
    id: 9003,
    personnelId: 'EMP005',
    name: 'Ali',
    surname: 'Şahin',
    email: 'ali.sahin@company.com',
    companyId: 2,
    companyName: 'Partner Co.',
    departmentId: 11,
    departmentName: 'Product',
    campusName: 'Ankara Office',
    routeGroupId: 103,
    routeGroup: 'Evening Shuttle A',
    routeId: 203,
    routeName: 'Route Gamma',
    stationId: 304,
    stationName: 'Çankaya Stop',
    schedule: 'VARIABLE',
    startDate: 20250401,
    endDate: 20250430,
  },
  {
    id: 9004,
    personnelId: 'EMP006',
    name: 'Zeynep',
    surname: 'Arslan',
    email: 'zeynep.arslan@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 13,
    departmentName: 'Finance',
    campusName: 'Istanbul HQ',
    routeGroupId: 104,
    routeGroup: 'Evening Shuttle B',
    routeId: 204,
    routeName: 'Route Delta',
    stationId: 305,
    stationName: 'Beşiktaş Stop',
    schedule: 'REGULAR',
    startDate: 20250101,
    endDate: 20250331,
  },
];

export const DUMMY_WORKGROUPS = [
  { id: 101, name: 'Morning Shuttle A' },
  { id: 102, name: 'Morning Shuttle B' },
  { id: 103, name: 'Evening Shuttle A' },
  { id: 104, name: 'Evening Shuttle B' },
];

export const DUMMY_ASSOCIATIONS = [
  {
    personnelId: 'EMP001',
    name: 'Ahmet',
    surname: 'Yılmaz',
    email: 'ahmet.yilmaz@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 10,
    departmentName: 'Engineering',
    campusName: 'Istanbul HQ',
    routeGroupId: 101,
    routeGroup: 'Morning Shuttle A',
    routeId: 201,
    routeName: 'Route Alpha',
    stationId: 301,
    stationName: 'Kadıköy Stop',
    walkingDistanceInMeter: 320,
    durationInMin: 25,
    schedule: 'REGULAR',
    assignment: 'Assigned',
  },
  {
    personnelId: 'EMP002',
    name: 'Ayşe',
    surname: 'Kaya',
    email: 'ayse.kaya@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 10,
    departmentName: 'Engineering',
    campusName: 'Istanbul HQ',
    routeGroupId: 101,
    routeGroup: 'Morning Shuttle A',
    routeId: 201,
    routeName: 'Route Alpha',
    stationId: 302,
    stationName: 'Bostancı Stop',
    walkingDistanceInMeter: 850,
    durationInMin: 30,
    schedule: 'REGULAR',
    assignment: null,
  },
  {
    personnelId: 'EMP003',
    name: 'Mehmet',
    surname: 'Demir',
    email: 'mehmet.demir@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 11,
    departmentName: 'Product',
    campusName: 'Istanbul HQ',
    routeGroupId: 102,
    routeGroup: 'Morning Shuttle B',
    routeId: 202,
    routeName: 'Route Beta',
    stationId: 303,
    stationName: 'Ümraniye Stop',
    walkingDistanceInMeter: 6200,
    durationInMin: 40,
    schedule: 'REGULAR',
    assignment: null,
  },
  {
    personnelId: 'EMP004',
    name: 'Fatma',
    surname: 'Çelik',
    email: 'fatma.celik@company.com',
    companyId: 2,
    companyName: 'Partner Co.',
    departmentId: 12,
    departmentName: 'HR',
    campusName: 'Istanbul HQ',
    routeGroupId: null,
    routeGroup: null,
    routeId: null,
    routeName: null,
    stationId: null,
    stationName: null,
    walkingDistanceInMeter: null,
    durationInMin: null,
    schedule: 'VARIABLE',
    assignment: null,
  },
  {
    personnelId: 'EMP005',
    name: 'Ali',
    surname: 'Şahin',
    email: 'ali.sahin@company.com',
    companyId: 2,
    companyName: 'Partner Co.',
    departmentId: 11,
    departmentName: 'Product',
    campusName: 'Ankara Office',
    routeGroupId: 103,
    routeGroup: 'Evening Shuttle A',
    routeId: 203,
    routeName: 'Route Gamma',
    stationId: 304,
    stationName: 'Çankaya Stop',
    walkingDistanceInMeter: 410,
    durationInMin: 18,
    schedule: 'VARIABLE',
    assignment: 'Assigned',
  },
  {
    personnelId: 'EMP006',
    name: 'Zeynep',
    surname: 'Arslan',
    email: 'zeynep.arslan@company.com',
    companyId: 1,
    companyName: 'Vektor A.Ş.',
    departmentId: 13,
    departmentName: 'Finance',
    campusName: 'Istanbul HQ',
    routeGroupId: 104,
    routeGroup: 'Evening Shuttle B',
    routeId: 204,
    routeName: 'Route Delta',
    stationId: 305,
    stationName: 'Beşiktaş Stop',
    walkingDistanceInMeter: 5400,
    durationInMin: 35,
    schedule: 'REGULAR',
    assignment: null,
  },
];
